"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sessionStorageAdapter = exports.persistMiddleware = exports.localStorageAdapter = exports.default = void 0;
var _middleware = require("zustand/middleware");
const persistMiddleware = function (id) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (blueprint) {
    return (0, _middleware.persist)(blueprint, {
      name: `storage-${id}`,
      // name of the item in the storage (must be unique)
      ...options
    });
  };
};
exports.persistMiddleware = persistMiddleware;
const sessionStorageAdapter = exports.sessionStorageAdapter = (0, _middleware.createJSONStorage)(function () {
  return sessionStorage;
});
const localStorageAdapter = exports.localStorageAdapter = (0, _middleware.createJSONStorage)(function () {
  return localStorage;
});
var _default = exports.default = persistMiddleware;